import styled from "styled-components";

// styles + components:
import Messages from "core/Messages";
import colors from "core/colors";
import { focusOutline } from "core/links";
import { textLg } from "core/fontStyles";
import { rapidEasing } from "core/animation";

// helpers:
import { convertPxToRem } from "frontend/components/helpers";
import BodyText from "core/BodyText";
import Modal from "core/Modal";
import { ModalContent, ModalFooter } from "core/Modal/styles";

// styled components:
export const FooterButton = styled.button`
    ${textLg}
    cursor: pointer;
    border: 0;
    padding: 0;
    margin: 0;
    background: transparent;
    color: ${colors.accent.lightMode.persian};
    transition: all ${rapidEasing};

    &:after {
        transition: all ${rapidEasing};
        position: relative;
        top: -${convertPxToRem({ px: 3 })};
        content: "";
        display: block;
        width: 100%;
        border-bottom: 1px solid ${colors.accent.lightMode.persian};
    }

    // only show focus on keyboard not with mouse:
    &:focus:not(.focus-visible) {
        outline: none;
        box-shadow: none;
        border: none;
    }

    &:focus {
        ${focusOutline}
    }

    &:hover {
        color: ${colors.secondary.cosmic};

        &:after {
            border-color: ${colors.secondary.cosmic};
        }
    }
`;

export const ReleaseMessageBanner = styled(Messages)`
    margin-bottom: ${convertPxToRem({ px: 16 })};

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const FilepickerInput = styled.input`
    display: none;
`;

////////////////////////////////////
///////// RELEASES MODAL ///////////
////////////////////////////////////

export const ModalContainer = styled(Modal)`
    ${ModalContent} {
        max-height: ${convertPxToRem({ px: 620 })};
    }

    ${ModalFooter} {
        justify-content: center;
    }
`;

export const ReleasesDropdownError = styled(BodyText).attrs({
    size: "md",
    type: "div",
    copyColor: colors.functional.lightMode.sangria
})``;

export const ReleasesDropdownErrorContainer = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
`;
